import { useState } from "react";
import "../../App.css";
import API from "../../API/api";
import { useNavigate } from "react-router-dom";

export default function Login() {
  const [formData, setformData] = useState({ email: "", password: "" });
  const navigate = useNavigate();

  const handleChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await API.post(
        "/auth/login",
        formData,
        { withCredentials: true }
      );
      const { token, user } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("userId", user.id);
      localStorage.setItem("username", user.name);

      navigate("/dashboard");
    } catch (err) {
      alert("Invalid email or password");
    }
  };

  return (
    <div className="login">
      <h2>Login</h2>
      <form onSubmit={handleLogin}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          autoComplete="username"
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
          autoComplete="current-password"
        />
        <button type="submit">Login</button>
      </form>
      <p>
  <a href="/forgot-password">
    Forgot Password?
  </a>
</p>
      <a href="/api/auth/google" className="btn-google">
        Continue with Google
      </a>
    </div>
  );
  
}

